import { createSelector } from 'reselect'
import { selectPrefersKbBillingVersion } from 'selectors/app/selectAccountPreferences'
import { showKbPlans } from '../util'
import { selectIsBillingDataLoaded } from './selectIsBillingDataLoaded'
import { selectCurrentKbPlan } from './selectCurrentKbPlan'

export const selectShowKbPlans = createSelector(
  selectIsBillingDataLoaded,
  selectCurrentKbPlan,
  selectPrefersKbBillingVersion,
  (isBillingDataLoaded, kbPlan, accountKbBillingVersion) => {
    return isBillingDataLoaded
      ? showKbPlans(kbPlan, accountKbBillingVersion)
      : undefined
  }
)
